import { appRoutes } from "../_routes/app-routes";
import { showSuccessMessage } from "../_uiComponents/ShowMessageSnack";

const useCopyToClipboard = () => {
  const getWebUrl = () => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const url = isDev
      ? `http://localhost:3000`
      : `${process.env.REACT_APP_DEV_ROOT_URL}`;

    return url;
  };

  const copyToClipboard = (url, hash_id) => {
    const newUrl = `${url}${appRoutes.assessementKit.scheduleEventLink}?event_link=${hash_id}`;
    showSuccessMessage(`Url copied ${newUrl}`);
    window.navigator.clipboard.writeText(newUrl);
  };

  return {
    copyToClipboard,
    getWebUrl,
  };
};

export default useCopyToClipboard;
